import React, { useState } from 'react';
import { Datagrid, useListContext } from 'react-admin';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { Skeleton, TableBody, TableCell, TableRow, Table } from '@mui/material';

import Drawer from './layout/Drawer';

const hasParentClass = (element, classnames) => {
	if (typeof element.className == 'string' && element.className && element.className.split(' ').some(elementClass => classnames.some(className => elementClass.includes(className)))) return true;
	return element.parentNode && hasParentClass(element.parentNode, classnames);
};

const DatagridSkeleton = ({ columns, rows }) => (
	<Table size="small">
		<TableBody>
			{[...Array(rows)].map((_, rowIndex) => (
				<TableRow key={rowIndex}>
					{[...Array(columns)].map((_, colIndex) => (
						<TableCell key={colIndex}>
							<Skeleton variant="text" width="80%" sx={{ fontSize: 16 }} />
						</TableCell>
					))}
				</TableRow>
			))}
		</TableBody>
	</Table>
);

const CustomDatagrid = ({ children, exclude = [], drawer, drawerActions, ...props }) => {
	const { isLoading } = useListContext();
	const [showDrawer, setShowDrawer] = useState(false);
	const [record, setRecord] = useState(null);
	const [prevRecord, setPrevRecord] = useState(null);

	const rowClick = (id, basePath, newRecord) => {
		setShowDrawer(true);
		setPrevRecord(record);
		setRecord(newRecord);
		return false;
	};

	const handleClose = () => {
		setShowDrawer(false);
		setRecord(null);
		setPrevRecord(null);
	};

	const handleClickAway = e => {
		// Check the nodeName is a weird fix for component with simple iterator and referenceinput
		if (e.target.nodeName === 'BODY' || hasParentClass(e.target, ['MuiDialog', 'RaAutocompleteInput'])) {
			e.stopPropagation();
			return;
		}

		if (prevRecord === null || record === null || prevRecord === record) {
			handleClose();
		}
		else {
			setPrevRecord(record);
		}
	};

	if (isLoading) {
		const columnCount = Array.isArray(children) ? children.length : 1;
		return <DatagridSkeleton columns={columnCount} rows={5} />;
	}

	return (
		<>
			<Datagrid {...props} rowClick={rowClick}>
				{children.map(child => {
					if (!child)
						return null;

					if (!child.props.label && !child.props.source)
						return child;
					return exclude.includes(child.props?.label?.toLowerCase()) || exclude.includes(child.props?.source?.toLowerCase()) ? null : child;
				})}
			</Datagrid>
			{(drawer && record) && (
				<ClickAwayListener onClickAway={handleClickAway}>
					<Drawer open={showDrawer} onClose={handleClose} record={record} basePath={props.basePath} actions={drawerActions}>
						{drawer}
					</Drawer>
				</ClickAwayListener>
			)}
		</>
	);
};

export default CustomDatagrid;
export { DatagridSkeleton };